export default from './input_text';



// WEBPACK FOOTER //
// ./frontend/react/components/common/input_text/index.js